import { OFFER_SHORT_DESCRIPTION_LIMIT } from '@webbuilder/schemas'
import { useI18n } from '../../../lib/i18n'

export function OfferDescriptionFields({ shortDescription, description, onShortDescriptionChange, onDescriptionChange, onFocus }: {
  shortDescription: string
  description: string
  onShortDescriptionChange: (value: string) => void
  onDescriptionChange: (value: string) => void
  onFocus: (zone: 'desc' | 'details' | null) => void
}) {
  const { t } = useI18n()
  return <>
    <label className="dash-svc-field">
      <span className="dash-svc-label-row">{t('offers.new.shortDescriptionLabel')}<em>{t('offers.new.optional')}</em></span>
      <textarea rows={2} maxLength={OFFER_SHORT_DESCRIPTION_LIMIT} value={shortDescription}
        placeholder={t('offers.new.shortDescriptionPlaceholder')}
        onFocus={() => onFocus('desc')} onBlur={() => onFocus(null)}
        onChange={(event) => onShortDescriptionChange(event.target.value)} />
      <small>{t('offers.new.shortDescriptionFoot')} · {shortDescription.length}/{OFFER_SHORT_DESCRIPTION_LIMIT}</small>
    </label>
    <label className="dash-svc-field">
      <span className="dash-svc-label-row">{t('offers.new.longDescriptionLabel')}<em>{t('offers.new.optional')}</em></span>
      <textarea rows={5} maxLength={5_000} value={description}
        placeholder={t('offers.new.descriptionPlaceholder')}
        onFocus={() => onFocus('details')} onBlur={() => onFocus(null)}
        onChange={(event) => onDescriptionChange(event.target.value)} />
      <small>{t('offers.new.longDescriptionFoot')}</small>
    </label>
  </>
}
